export const salesPurchasesExcludingVAT = [
    {
        box: 6,
        details: 'Total value of sales and all other outputs excluding any VAT',
        amount: 463.67,
    }, {
        box: 7,
        details: 'Total value of purchase and all other outputs excluding any VAT',
        amount: 467.00,
    }
]

export const ECSuppliesPurchasesExcludingVAT = [
    {
        box: 8,
        details: 'Total value of supplies of goods and related cost ( excluding VAT) from Northern Ireland to EU Member States',
        amount: 463.67,
    }, {
        box: 9,
        details: 'Total value of acquisitions of goods and related cost ( excluding VAT) from EU Member States to Northern Ireland',
        amount: 467.00,
    }
]

export const calculationTempData = [
    {
        box: 1,
        details: 'VAT due in the period on sales and other outputs',
        amount: 468.67,
    }, {
        box: 2,
        details: 'VAT due in the period on acquisitions of goods made in Northern Ireland from EU Member States',
        amount: 468.67,
    }, {
        box: 3,
        details: 'Total VAT due (the sum of boxes 1 and 2)',
        amount: 468.67,
    },
    {
        box: 4,
        details: 'VAT reclaimed in the period on purchase and other inputs ( including acquisitions in Northern Ireland from EU Member States)',
        amount: 468.67,
    }, {
        box: 5,
        details: 'Total VAT due (the sum of boxes 1 and 2)',
        amount: 468.67,
    },
]

export const VAT_BOX_CALCULATION_FIELDS = {
    1: 'vatDueSales',
    2: 'vatDueAcquisitions',
    3: 'totalVatDue',
    4: 'vatReclaimedCurrPeriod',
    5: 'netVatDue',
    6: 'totalValueSalesExVAT',
    7: 'totalValuePurchasesExVAT',
    8: 'totalValueGoodsSuppliedExVAT',
    9: 'totalAcquisitionsExVAT',
};

export const SALES_TAB_BOXES = [1, 6];
export const PURCHASE_TAB_BOXES = [4, 5];

const allVatReturnBoxes = [
    ...calculationTempData,
    ...salesPurchasesExcludingVAT,
    ...ECSuppliesPurchasesExcludingVAT,
];

export const getVatReturnBox = (box) => allVatReturnBoxes.find((item) => item.box === box);
